/** Header bar + `WorkerHostingInfo` variant="header" share these bounds. */
export const HEADER_HOSTING_MIN_HEIGHT_CLASS =
    'min-h-[max(2.9rem,min(4.1rem,9.2vh))]';

export const HEADER_HOSTING_HEIGHT_CLASSES = `${HEADER_HOSTING_MIN_HEIGHT_CLASS} max-h-[max(2.9rem,min(4.1rem,9.2vh))]`;
